export enum TelegramStatusEnum {
  NONE = 0,
  PENDING_TO_CREATING_GROUP = 1,
  ACTIVED_GROUP = 2,
}

export const TelegramStatusLabels: Record<keyof typeof TelegramStatusEnum, string> = {
  NONE: 'NONE',
  PENDING_TO_CREATING_GROUP: 'PENDING_TO_CREATING_GROUP',
  ACTIVED_GROUP: 'ACTIVED_GROUP',
};